import { io } from "socket.io-client";
import { useToast } from 'vue-toastification';
const toast = useToast();
import { defineStore } from "pinia";
import _ from "lodash";
var ToastAll = {}
let socket, socketPrice;

const initializeSocket = () => {
    if (!socket) {
        socket = io(useRuntimeConfig().public.socketUrl, {
            path: "/socket",
            autoConnect: false,
            transports: ['websocket'],
        });
    }
    return socket;
};

const initializeSocketPrice = () => {
    if (!socketPrice) {
        socketPrice = io(useRuntimeConfig().public.priceUrl, {
            autoConnect: false,
            transports: ['websocket'],
        });
    }
    return socketPrice;
};

export const useSocketStore = defineStore("socket", {
    state: () => ({
        coinData: [],
        orderBook: { asks: [], bids: [] },
        trades: [],
        balances: 0,
        selectedSymbols: 'btc',
        changeStatuss: false,
        showTradeCharts: true,
    }),

    getters: {
        coins: (state) => state.coinData,
        orderBooks: (state) => state.orderBook,
        selectedSymbol: (state) => state.selectedSymbols,
        showTradeChart: (state) => state.showTradeCharts,
        trade: (state) => state.trades,
        balance: (state) => state.balances,
        changeStatus: (state) => state.changeStatuss,
        selectedCoin: (state) => state.coinData[state.selectedSymbols],
    },

    actions: {
        connectLogin(id) {
            const socket = initializeSocket();
            socket.connect();
            socket.emit("login", localStorage.token, id);

            socket.once("login", (data) => {
                if (!data.login) {
                    localStorage.clear()
                    toast.success("Need to Login");
                    window.location = '/login'
                } else {
                    socket.on("balance", (data) => {
                        this.balances = data.balance
                    })
                    socket.on("trades", (data) => {
                        this.trades = data;
                    });
                    socket.on("limitopened", (data) => {
                        if (!ToastAll["limitopened"]) {
                            ToastAll["limitopened"] = new Date()
                            toast.warning("Limit Opened");
                        } else {
                            if (Number(new Date()) - Number(ToastAll["limitopened"]) >= 10000) {
                                ToastAll["limitopened"] = new Date()
                                toast.warning("Limit Opened");
                            }
                        }
                        this.changeStatuss = true
                    })
                    socket.on("position_tp", (data) => {
                        if (!ToastAll["position_tp"]) {
                            ToastAll["position_tp"] = new Date()
                            toast.warning("Tp Touch");
                        } else {
                            if (Number(new Date()) - Number(ToastAll["position_tp"]) >= 10000) {
                                ToastAll["position_tp"] = new Date()
                                toast.warning("Tp Touch");
                            }
                        }
                        this.changeStatuss = true
                    })
                    socket.on("position_sl", (data) => {
                        if (!ToastAll["position_sl"]) {
                            ToastAll["position_sl"] = new Date()
                            toast.warning("Sl Touch");
                        } else {
                            if (Number(new Date()) - Number(ToastAll["position_sl"]) >= 10000) {
                                ToastAll["position_sl"] = new Date()
                                toast.warning("Sl Touch");
                            }
                        }
                        this.changeStatuss = true
                    })
                    socket.on("block", (data) => {
                        if (!ToastAll["block"]) {
                            ToastAll["block"] = new Date()
                            toast.warning("You are Blocked");
                        } else {
                            if (Number(new Date()) - Number(ToastAll["block"]) >= 10000) {
                                ToastAll["block"] = new Date()
                                toast.warning("You are Blocked");
                            }
                        }
                        this.changeStatuss = true
                    })
                }
            });
        },

        connectPrice() {
            const socketPrice = initializeSocketPrice();
            socketPrice.connect();
            socketPrice.emit("join", "price");

            socketPrice.on("price", (data) => {
                this.coinData = data;
            });
        },

        connectOrderbook(coin) {
            const socketPrice = initializeSocketPrice();
            this.orderBook = { asks: [], bids: [] };
            socketPrice.connect();
            socketPrice.emit("join", coin);
            const throttledUpdate = _.throttle((orderBook) => {
                this.orderBook = {
                    asks: orderBook.asks,
                    bids: orderBook.bids,
                };
            }, 500);
            socketPrice.on("orderbook", (symbol, orderBook) => {
                if (this.selectedSymbols.toLowerCase() === symbol.toLowerCase()) {
                    throttledUpdate(orderBook);
                }
            });
        },

        callOrderBook(coin) {
            const socketPrice = initializeSocketPrice();
            socketPrice.emit("join", coin);
        },

        changeSelectedSymbol(symbol) {
            this.showTradeCharts = false;

            this.connectOrderbook(symbol);
            this.selectedSymbols = symbol;

            setTimeout(() => {
                this.showTradeCharts = true;
            }, 200);
        },

        cleanupSockets() {
            if (socket) {
                socket.removeAllListeners();
                socket.disconnect();
            }
            if (socketPrice) {
                socketPrice.removeAllListeners();
                socketPrice.disconnect();
            }
        },
    },
});
